import Vue from 'vue'
import axios from 'axios'
import AuthService from '@/services/authentication.service'
import store from '@/store'

Vue.use(AuthService)

const $http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  withCredentials: false,
  crossDomain: false,
  params: {}
})

$http.interceptors.request.use(request => {
  request.headers['Accept-Language'] = document.documentElement.lang
  if (request.url.includes('auth')) {
    request.headers.Authorization = Vue.prototype.$auth.bearer()._token
    request.headers.Accept = 'application/json'
    request.headers['X-Website'] = store.getters.GET_WEBSITE
  }
  return request
})

$http.interceptors.response.use(response => {
  // eslint-disable-next-line no-prototype-builtins
  if (response.data.hasOwnProperty('access_token')) {
    store.dispatch('setRole', response.data.role).catch()
    Vue.prototype.$auth.store(`${response.data.token_type} ${response.data.access_token}`, response.data.expires_at)
  }
  // eslint-disable-next-line no-prototype-builtins
  if (response.data.hasOwnProperty('message')) {
    store.dispatch('setAlert', { show: true, type: 'success', message: response.data.message }).then()
  }
  return response
}, error => {
  switch (error.response.status) {
  case 401:
  case 500:
    store.dispatch('setAlert', { show: true, type: 'error', message: error.response.data.error }).then()
    break
  default:
    break
  }
})

const HttpService = {
  install (Vue) {
    Vue.prototype.$http = $http
  }
}

export default (HttpService)
